var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "button-blue-cart") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.0002 36 0.0002 36 37.4901 0 37.4901"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 0.0004 23.9995049 0.0004 23.9995049 20.314 0 20.314"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "button-blue-cart",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "button-background",
    transform: "translate(0.000000, -1.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,1 C8.07525353,1 -0.0005,9.07479328 -0.0005,19 L-0.0005,37 C5.38302885,37 11.3831955,37 18,37 C27.9252067,37 36,28.9252067 36,19 C36,9.07479328 27.9252067,1 18,1 Z",
    id: "Fill-1",
    fill: "#32507E",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(6.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.7627,12.2754 L19.5937,12.4094 L22.1747,5.4174 L5.2767,5.3774 L6.7627,12.2754 Z M3.9197,15.9734 C3.1307,15.9734 2.4897,16.6104 2.4897,17.3944 C2.4897,18.1764 3.1307,18.8144 3.9197,18.8144 C4.7087,18.8144 5.3517,18.1764 5.3517,17.3944 C5.3517,16.6104 4.7087,15.9734 3.9197,15.9734 L3.9197,15.9734 Z M16.6597,15.9734 C15.8717,15.9734 15.2307,16.6104 15.2307,17.3944 C15.2307,18.1764 15.8717,18.8144 16.6597,18.8144 C17.4497,18.8144 18.0907,18.1764 18.0907,17.3944 C18.0907,16.6104 17.4497,15.9734 16.6597,15.9734 L16.6597,15.9734 Z M16.6597,20.3144 C15.3047,20.3144 14.1607,19.3924 13.8277,18.1444 L6.7537,18.1444 C6.4197,19.3924 5.2767,20.3144 3.9197,20.3144 C2.3037,20.3144 0.9897,19.0044 0.9897,17.3944 C0.9897,15.7634 2.3657,14.4294 3.9807,14.4734 L5.3457,12.8214 L3.6187,4.7984 C3.6117,4.7654 3.6057,4.7314 3.6017,4.6964 L3.1057,1.5004 L0.7497,1.5004 C0.3357,1.5004 -0.0003,1.1644 -0.0003,0.7504 C-0.0003,0.3364 0.3357,0.0004 0.7497,0.0004 L3.7477,0.0004 C4.1177,0.0004 4.4327,0.2694 4.4897,0.6354 L4.9917,3.8764 L23.2517,3.9204 C23.4967,3.9204 23.7257,4.0404 23.8667,4.2414 C24.0057,4.4424 24.0377,4.6994 23.9527,4.9294 L20.8177,13.4244 C20.7077,13.7224 20.4467,13.9134 20.1067,13.9154 L6.5057,13.7734 L5.5307,14.9544 C6.1227,15.3434 6.5667,15.9424 6.7537,16.6444 L13.8277,16.6444 C14.1607,15.3954 15.3047,14.4734 16.6597,14.4734 C18.2767,14.4734 19.5907,15.7834 19.5907,17.3944 C19.5907,19.0044 18.2767,20.3144 16.6597,20.3144 L16.6597,20.3144 Z",
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cart-icon.fff5b116658fa938fca8175174325167.svg";
export { ForwardRef as ReactComponent };